export const addNumericPadding = (n) => {
  return n >= 10 ? n : `0${n}`;
};
